module.exports = __webpack_public_path__ + "assets/e464995b45c71f01cae9a1e4ab036964.svg";